import { TournamentInvitation } from '../models';
import { TournamentInvitationRepository } from '../repositories/TournamentInvitationRepository';
import { ParticipantRepository, TournamentRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class AcceptTournamentInvitationUseCase {
  constructor(
    private invitationRepository: TournamentInvitationRepository,
    private participantRepository: ParticipantRepository,
    private tournamentRepository: TournamentRepository
  ) {}

  async execute(params: {
    invitationId: string;
    inviteeId: string;
    inviteeName: string;
  }): Promise<TournamentInvitation> {
    const { invitationId, inviteeId, inviteeName } = params;

    logger.debug('AcceptInvitation', 'Accepting invitation', { invitationId });

    // Update invitation status
    const invitation = await this.invitationRepository.accept(invitationId);

    // Add invitee as participant
    const tournament = await this.tournamentRepository.getById(invitation.tournamentId);
    if (!tournament) {
      throw new Error('Tournament not found');
    }

    if (tournament.status !== 'setup') {
      throw new Error('Tournament is no longer accepting participants');
    }

    const existingParticipants = await this.participantRepository.getByTournamentId(invitation.tournamentId);
    const isAlreadyParticipant = existingParticipants.some((p) => p.userId === inviteeId);

    if (!isAlreadyParticipant) {
      const seed = existingParticipants.length + 1;
      await this.participantRepository.create({
        tournamentId: invitation.tournamentId,
        name: inviteeName,
        seed,
        userId: inviteeId,
      });
      logger.debug('AcceptInvitation', 'Participant added to tournament');
    }

    return invitation;
  }
}
